import { B2B_PROALLOWANCE_V2_PATH, B2B_PROALLOWANCE_RETRIEVE_PAA_CARDS_PATH, B2B_PROALLOWANCE_RETRIEVE_ALL_PMT_CARDS_PATH, B2B_PROALLOWANCE_V1_PATH, B2B_PROALLOWANCE_CREATE_WITH_AUTH_PATH, } from '../constants/links';
import { apiBase } from './axios-client';
export var proAllowanceApi = {
    createProAllowanceWithAuth: function (_a) {
        var runnerAllowanceRequest = _a.runnerAllowanceRequest, tmx = _a.tmx;
        return apiBase.post(B2B_PROALLOWANCE_CREATE_WITH_AUTH_PATH, {
            RunnerAllowanceWrapper: {
                runnerAllowanceRequest: runnerAllowanceRequest,
                tmx: tmx,
            },
        });
    },
    disableAllowance: function (_a) {
        var allowanceId = _a.allowanceId;
        return apiBase.put(B2B_PROALLOWANCE_V2_PATH, {
            RunnerAllowanceRequest: {
                allowanceId: allowanceId,
            },
        });
    },
    deleteAllowance: function (_a) {
        var allowanceId = _a.allowanceId;
        return apiBase.delete("".concat(B2B_PROALLOWANCE_V2_PATH, "/").concat(allowanceId, "/deleteRunnerAllowance"));
    },
    getAllowances: function () {
        return apiBase.get(B2B_PROALLOWANCE_V2_PATH);
    },
    getAllProAllowanceUsers: function (filterActiveUsers) {
        if (filterActiveUsers === void 0) { filterActiveUsers = true; }
        return apiBase.get("".concat(B2B_PROALLOWANCE_V1_PATH, "/getAllUsers?filterActiveUsers=").concat(filterActiveUsers));
    },
    getAllPAACards: function () {
        return apiBase.get(B2B_PROALLOWANCE_RETRIEVE_PAA_CARDS_PATH);
    },
    getAllPmtCards: function () {
        return apiBase.get(B2B_PROALLOWANCE_RETRIEVE_ALL_PMT_CARDS_PATH);
    },
};
